import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Servicepagebanner from '../components/Servicepagebanner';

function KRAs_KPIs() {
  return (
    <div>
      <Header/>
     <Servicepagebanner/>
       <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <div className="col-lg-8 m-auto">
                <div className="service-main-content heading1">
                    <h2>KRA’s & KPI’s </h2>
                    <div className="space16"></div>
                        <p>Clarity is the foundation of high performance, and at JBY Talent Acquisition & Management Private Limited, we help companies establish precise Key Result Areas (KRAs) and Key Performance Indicators (KPIs) that set measurable, actionable goals for employees. </p>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/service2/KRA’s_&_KPI’s.png" alt=""/>
                    </div>
                    <div className="space32"></div>
                    
                    <p>Our team works closely with your leadership to map every role to specific objectives, output expectations, and timelines, ensuring a clear understanding of responsibilities at every level. These metrics empower managers with data-backed insights to track progress, evaluate contributions, and make informed decisions. </p>                    
                    <div className="space32"></div>
                    
<p>For employees, well-defined KRAs and KPIs bring direction, focus, and motivation while eliminating ambiguity in performance expectations. The result is a highly accountable, goal-oriented workforce that drives business growth and delivers measurable results.</p>                    
                    <div className="space32"></div>
                  
                    <div className="space32"></div>
                   
                </div>
            </div>
        </div>
    </div>
</div>


      <Footer/> 
    </div>
  )
}

export default  KRAs_KPIs;
